import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const EmptyStateLoading = () => /*#__PURE__*/_jsx(View, {
  as: "div",
  padding: "800",
  inlineSize: "100%",
  children: /*#__PURE__*/_jsx(LoadingSpinner, {
    size: "medium"
  })
});
export default EmptyStateLoading;